import { mapGetters, mapActions } from 'vuex';
import { ComplexFieldMixin } from '@/mixins/ComplexFieldMixin';

export const SimpleFieldMixin = {
    data() {
        return {};
    },
    methods: {
        ...mapActions(['setProp']),
        /* init */
        async init() {
            await this.saveUndefinedFieldsAfterCreation();
            await this.autoformatValue();
        },
        /* validate */
        validate(val) {
            if (
                (this.required && (val === undefined || val === null || val === '')) ||
                (this.pattern &&
                    val !== undefined &&
                    val !== null &&
                    val !== '' &&
                    !new RegExp(this.pattern).test(val))
            ) {
                return false;
            } else if (
                (this.required && val !== undefined && val !== null && val !== '') ||
                (this.pattern &&
                    (val === undefined ||
                        val === null ||
                        val === '' ||
                        new RegExp(this.pattern).test(val)))
            ) {
                return true;
            }
            // return null instead of true if both required or pattern is not set
            // then we save one write and check to the differ (performance)
            return null;
        },
        /* custom setters */
        async simpleFieldSet(newValue) {
            if (newValue === this.simpleFieldGet) {
                return;
            }
            if (this.dataSource === undefined) {
                this.$emit('input', newValue);
                return;
            }
            await this.componentDifferChange();
            await this.setProp({ source: this.dataSource, value: newValue });
            await this.componentDifferValidate();
        },
        async saveUndefinedFieldsAfterCreation() {
            if (
                this.dataSource === undefined &&
                this.dataDefault !== undefined &&
                (this.value === undefined || this.value === null)
            ) {
                this.$emit('input', this.getDefaultText);
                return;
            }
            // this is only done when the field is entirely not set (if it is '', nothing happens here)
            if (
                this.getProp(this.dataSource) === undefined ||
                this.getProp(this.dataSource) === null
            ) {
                await this.setProp({
                    source: this.dataSource,
                    value: this.getDefaultText
                });
            }
        },
        async autoformatValue() {
            if (this.autoformat !== undefined && this.autoformat !== null) {
                if (
                    this.simpleFieldGet !== undefined &&
                    this.simpleFieldGet !== null &&
                    this.simpleFieldGet !== ''
                ) {
                    if (this.autoformat === 'phone') {
                        let val = this.simpleFieldGet;
                        val = val.split('++').join('+');
                        if (val.substring(0, 1) === '0') {
                            val = '+49' + val.substring(1);
                        }
                        await this.simpleFieldSet(val);
                    }
                    if (this.autoformat === 'url') {
                        let val = this.simpleFieldGet;
                        if (val.indexOf('http://') !== 0 && val.indexOf('https://') !== 0) {
                            val = 'https://' + val;
                        }
                        await this.simpleFieldSet(val);
                    }
                }
            }
        },
        async stripHtmlTags() {
            if (
                this.simpleFieldGet !== undefined &&
                this.simpleFieldGet !== null &&
                this.simpleFieldGet !== ''
            ) {
                let valOld = this.simpleFieldGet,
                    valNew = valOld.replace(/<\/?[^>]+(>|$)/g, '');
                if (valNew !== valOld) {
                    await this.simpleFieldSet(valNew);
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'getProp',
            'isShadowed',
            'getCurrentRouteFullPath',
            'getRandomTextInNamespace'
        ]),
        simpleFieldGet() {
            if (this.dataSource === undefined) {
                return this.value;
            }
            let val = this.getProp(this.dataSource);
            if (val === undefined) {
                return '';
            }
            return val;
        },
        checkDisabled() {
            return this.disabled || this.isShadowed(this.dataSource, this.dataPreset);
        },
        getDefaultText() {
            let val = '';
            if (this.dataDefault !== undefined) {
                if (this.dataDefault.type === 'textpicker') {
                    val = this.getRandomTextInNamespace(this.textpickerNamespace);
                } else if (this.dataDefault.type === 'source') {
                    val = this.getProp(this.dataDefault.value);
                } else if (this.dataDefault.type === 'raw') {
                    val = this.dataDefault.value;
                } else if (this.dataDefault.type === 'random') {
                    if (this.options && Array.isArray(this.options) && this.options.length > 0) {
                        val = this.options[Math.floor(Math.random() * this.options.length)];
                    }
                    if (
                        this.options &&
                        typeof this.options === 'object' &&
                        Object.keys(this.options).length > 0
                    ) {
                        val = Object.keys(this.options)[
                            Math.floor(Math.random() * Object.keys(this.options).length)
                        ];
                    }
                } else if (this.dataDefault.type === 'first') {
                    if (this.options && Array.isArray(this.options) && this.options.length > 0) {
                        val = this.options[0];
                    }
                    if (
                        this.options &&
                        typeof this.options === 'object' &&
                        Object.keys(this.options).length > 0
                    ) {
                        val = Object.keys(this.options)[0];
                    }
                }
            }
            return val;
        },
        simpleFieldModel: {
            get() {
                return this.simpleFieldGet;
            },
            set(newValue) {
                return this.simpleFieldSet(newValue);
            }
        }
    },
    mixins: [ComplexFieldMixin],
    props: {
        label: String,
        required: Boolean,
        pattern: String,
        dataSource: String,
        dataPreset: [String, Boolean],
        dataDefault: null,
        disabled: Boolean,
        textpickerNamespace: [String, Array],
        maxlength: Number,
        value: null,
        autoformat: String
    }
};
